
import HymnApp from './view.js';
import FirebaseUser from './firebase.js';

export default class HymnAppController {

  constructor() {

    // vars
    this.model = new FirebaseUser();
    this.reactRoot = document.querySelector('#container');

    // actions
    this.model.on('load', () => {
      this.storeActions();
      this.mountView();
    });

  }

  storeActions() {

    this.modelActions = {
      favorite: n => this.model.favorite(n),
      recent: n => this.model.recent(n),
      setTheme: a => this.model.setTheme(a),
      setLanguage: l => this.model.setLanguage(l),
      setHymnal: h => this.model.setHymnal(h),
      signIn: p => this.model.signInProvider(p),
      link: p => this.model.linkProvider(p),
      unlink: pid => this.model.unlinkProvider(pid),
      logout: () => this.model.logout()
    }

  }

  mountView() {

    this.renderView();

    this.model.on('data update', () => this.renderView());
    this.model.on('server update', () => this.renderView()); // <-- better, though non-existent

  }

  renderView() {

    ReactDOM.render(
      <HymnApp
        hymnal={data}
        user={this.model.simpleUser}
        popular={this.model.popularHymns}
				hymnUsageLogs={this.model.hymnUsageLogs}
        actions={this.modelActions} />,
      this.reactRoot
    );

  }

}

